export default __webpack_public_path__ + "static/media/derivacion.a36bc18b.svg";